import { render, staticRenderFns } from "./WSectorEdit.vue?vue&type=template&id=3ae4a1d3&"
import script from "./WSectorEdit.vue?vue&type=script&lang=ts&"
export * from "./WSectorEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports